import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { Separator } from "../separator/Separator.js";
import styles from "./EditorToolbar.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EditorToolbar = /*#__PURE__*/forwardRef(({
  sections,
  className,
  style,
  children
}, ref) => {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.toolbar, className),
    ref: ref,
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.sections,
      children: sections.map((section, index) => /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.section,
          children: section.items.map((item, index) => /*#__PURE__*/_jsx(React.Fragment, {
            children: item
          }, item.key ?? index))
        }), index !== sections.length - 1 && /*#__PURE__*/_jsx(Separator, {
          variant: "VERTICAL"
        })]
      }, section.key))
    }), children && /*#__PURE__*/_jsx("div", {
      className: styles.additional,
      children: children
    })]
  });
});